import { FetchUtil } from "../util/FetchUtil";
import { ICertificateServiceEndpoint } from "../models/Certificate/ICertificateServiceEndpoint"
import { ICertificatePathResponse } from "../models/Certificate/ICertificatePathResponse"
import { ICertificateZipRequest } from "../models/Certificate/ICertificateZipRequest"
import { ICertificateZipResponse } from "../models/Certificate/ICertificateZipResponse"
import { ICertificateEmailZipRequest } from "../models/Certificate/ICertificateEmailZipRequest"
import { StringUtil } from "../util/StringUtil";

export class CertificateService {
  constructor(private readonly _endpoint: ICertificateServiceEndpoint) {}

  public async zip(request: ICertificateZipRequest): Promise<ICertificateZipResponse>{
    const endpoint = this._endpoint;
    if (!endpoint) {
      throw new Error("Could not resolve endpoint.");
    }
    if (!endpoint.zip) {
      throw new Error("Could not resolve endpoint.");
    }

    const url = endpoint.zip.url;
    const result = await FetchUtil
      .sendMessage({ method: endpoint.zip.method, url }, request, "default", false);

    const response = result as ICertificateZipResponse;

    return response;
  }

  public async path(activityId: string): Promise<ICertificatePathResponse> {
    const endpoint = this._endpoint;
    if (!endpoint) {
      throw new Error("Could not resolve endpoint.");
    }
    if (!endpoint.path) {
      throw new Error("Could not resolve endpoint.");
    }


    const url = (StringUtil.supplant(endpoint.path.url, { activityId }) || "")
    .replace(/\{(?:activityId)\}/g, "");

    const result = await FetchUtil
      .sendMessage({ method: endpoint.path.method, url }, null);

    const response = result as ICertificatePathResponse;

    return response;
  }

  public async email(datasourceId: string): Promise<void> {
    const endpoint = this._endpoint;
    if (!endpoint) {
      throw new Error("Could not resolve endpoint.");
    }

    const activity = window.Activity;
    if (!activity || !activity.Id) {
      throw new Error("No global activity context.");
    }

    const body = {
      EmailDataSource: datasourceId,
      activityId: activity.Id,
    };

    try {
      await FetchUtil.sendMessage(endpoint.email, body);
    } catch {
      console.log("Error in CertificateService.email()");
    }
  }

  public async emailZip(request:ICertificateEmailZipRequest ): Promise<void> {
    const endpoint = this._endpoint;
    if (!endpoint?.emailzip) {
      throw new Error("Could not resolve endpoint.");
    }

    FetchUtil.sendMessage(endpoint.emailzip, request, "default", false);
  }
}
